import { gql } from '@apollo/client'

export const ACTION_COMPLETE_FRAGMENT = gql`
  fragment ActionComplete on ActionComplete {
    id
    startTime
    endTime
    images {
      id
      url
    }
    aiCheckResult {
      id
      passed
      notes
      created
    }
    completedBy {
      id
      firstName
      lastName
      email
    }
    action {
      title
      store {
        location {
          name
        }
      }
    }
  }
`
